

const SERVER_API = "ServerApi";
const SERVER_CRM="ServerCRM";
const CURRENT_DATABASE="cloudcalls";

const DEFAULT_MODULES=[
    {key: "vehicle", val: "Vehicle"},
    {key: "driver", val: "Driver"},
    {key: "authorizer", val: "Authorizer"},
    {key: "customer", val: "Customer"},

];

export{
    SERVER_API,
    SERVER_CRM,
    CURRENT_DATABASE,
    DEFAULT_MODULES
}
